import React from "react";
import ShareButton from "./ShareButton";
import Icon, { SETTING_ICONS } from "./Icon";
import { NdGear, CardGear } from "./GearRecommendation";

function Row({ label, value, icon }) {
  return (
    <div className="mobile-settings-row">
      <span className="row-label">
        {icon && <Icon name={SETTING_ICONS[icon] || "aperture"} size={14} />}
        {label}
      </span>
      <span className="row-value data">{value}</span>
    </div>
  );
}

export default function MobileSettingsCard({ camera, scenario, lighting, recipe, explanation }) {
  const { settings, bonus } = recipe;

  return (
    <div className="mobile-card">
      <div className="mobile-card-header">
        <div className="mobile-card-eyebrow">{camera.name}</div>
        <h1>{scenario.name}</h1>
        <div className="mobile-card-sub">{lighting.name}</div>
        {typeof window !== "undefined" && (
          <ShareButton
            title={`${camera.name} — ${scenario.name} Settings`}
            text={`${scenario.name} settings for the ${camera.name} in ${lighting.name.toLowerCase()}`}
            url={window.location.href}
            className="mobile-share-button"
          />
        )}
      </div>

      <div className={`mobile-confidence conf-${explanation.confidenceTone}`}>
        <span className="mobile-confidence-dot" aria-hidden="true" />
        {explanation.confidenceLabel}
      </div>

      <div className="mobile-settings-list">
        <Row icon="resolution" label="Resolution" value={settings.resolution} />
        {settings.aspectRatio && <Row icon="aspectRatio" label="Aspect ratio" value={`${settings.aspectRatio} (${settings.outputName})`} />}
        <Row icon="fps" label="Frame rate" value={`${settings.fps}fps`} />
        <Row icon="shutter" label="Shutter" value={settings.shutter} />
        <Row icon="iso" label="ISO" value={settings.iso} />
        <Row icon="whiteBalance" label="White balance" value={settings.whiteBalance} />
        <Row icon="colorTemperature" label="Color temperature" value={settings.colorTemperature} />
        <Row icon="profile" label="Profile" value={settings.profile} />
        <Row icon="sharpness" label="Sharpness" value={settings.sharpness} />
        <Row icon="contrast" label="Contrast" value={settings.contrast} />
        <Row icon="saturation" label="Saturation" value={settings.saturation} />
        <Row icon="ndFilter" label="ND filter" value={settings.ndFilter} />
        <Row icon="stabilization" label="Stabilization" value={settings.stabilization} />
        <Row icon="focus" label="Focus" value={settings.focus} />
      </div>

      {settings.ndNote && <p className="mobile-note">{settings.ndNote}</p>}

      <NdGear camera={camera} settings={settings} />

      {bonus && (bonus.sdCard || bonus.panning) && (
        <div className="mobile-bonus-section">
          <div className="mobile-bonus-label">Unlocked bonus tips</div>

          {bonus.sdCard && (
            <>
              <div className="mobile-settings-list">
                <Row icon="sdCard" label="Recommended SD card" value={bonus.sdCard.speedClass} />
              </div>
              <p className="mobile-note">{bonus.sdCard.note}</p>
            </>
          )}

          {bonus.sdCard && <CardGear sdCard={bonus.sdCard} />}

          {bonus.panning && (
            <p className="mobile-note">
              <strong>Panning:</strong> {bonus.panning.guidance}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
